import { FC } from 'react';
import { CardContainer } from './Card.styles';
import { CardProps } from './types';

export const Card: FC<CardProps> = ({ children, borderColor, className }) => (
  <CardContainer borderColor={borderColor} className={className} data-cy="card">
    {children}
  </CardContainer>
);
